import { useEffect } from 'react';

const useClickOutside = (ref, clickOutside, buttonId?) => {
  const handleClickOutside = (event) => {
    if (ref.current) {
      if (event.target.id === buttonId) {
        return;
      }
      if (ref.current.contains) {
        if (!ref.current.contains(event.target)) {
          clickOutside();
        }
      }
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
};

export default useClickOutside;
